import React, { useEffect } from "react";
import 'jquery.easing'

import $ from "jquery";
import FooterUI from './FooterUI'
const Footer = (props) => {


  useEffect(()=>{
    
    
      $(".amg-floating-icon").on("mouseenter", function () {
          $(this).closest(".amg-floating-contact-wrap").addClass("hover")
      });
      $(".amg-floating-contact-wrap").on("mouseleave", function () {
          $(this).removeClass("hover");
      });
  




  })
  
  
  
  return (
    <div>
     <FooterUI footerClass={props.footerClass} />
    </div>
  );
};

export default Footer;
